import {
  getCodesFromLC,
  getDataFromServer,
  setCodesJSONToLC
} from '../../../util';
import {
  FeatureCategoryCodes_LC,
  FeatureCodes_LC
} from '../../../../util/GlobalConstant';

export class FeatureCodesModule {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  featureCodes = async () => {
    let featureCodesData = [];
    featureCodesData = await getCodesFromLC(FeatureCodes_LC);
    if (featureCodesData.length === 0) {
      const params = {
        codeType: 'FEATURE_DESCRIPTION_CODE'
      };
      const featureCodesResponse = await getDataFromServer(
        `${this.baseURL}/codes`,
        this.httpHeaders,
        params
      );
      await setCodesJSONToLC(FeatureCodes_LC, featureCodesResponse);
      return featureCodesResponse;
    }
    return featureCodesData;
  };

  featureCategoryCodes = async () => {
    let featureCategoryCodesData = [];
    featureCategoryCodesData = await getCodesFromLC(FeatureCategoryCodes_LC);
    if (featureCategoryCodesData.length === 0) {
      const params = {
        codeType: 'FEATURE_CATEGORY_CODE'
      };
      const featureCategoryCodeResponse = await getDataFromServer(
        `${this.baseURL}/codes`,
        this.httpHeaders,
        params
      );
      await setCodesJSONToLC(
        FeatureCategoryCodes_LC,
        featureCategoryCodeResponse
      );
      return featureCategoryCodeResponse;
    }
    return featureCategoryCodesData;
  };
}
